module.exports = __webpack_public_path__ + "37980905e855660d04d4225b93693801.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/antlers.png
// module id = 2767
// module chunks = 0